import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import {
  IMealCreditFormFields,
  Meridian,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { TimeIntervalTypeValues } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { calculateTimeIntervalType } from 'src/components/oneCorp/features/MealCredit/utils/calculateTimeIntervalType';

type TimeRangeFields = Pick<
  IMealCreditFormFields,
  'startTime' | 'startTimeMeridian' | 'endTime' | 'endTimeMeridian'
>;

const DEFAULT_TIME_RANGE: Record<TimeIntervalTypeValues, TimeRangeFields> = {
  [TimeIntervalTypeValues.ALL_DAY]: {
    startTime: '12:00',
    startTimeMeridian: Meridian.AM,
    endTime: '11:59',
    endTimeMeridian: Meridian.PM,
  },
  [TimeIntervalTypeValues.HOURS]: {
    startTime: '6:00',
    startTimeMeridian: Meridian.AM,
    endTime: '6:00',
    endTimeMeridian: Meridian.PM,
  },
  [TimeIntervalTypeValues.OVERNIGHT]: {
    startTime: '6:00',
    startTimeMeridian: Meridian.PM,
    endTime: '6:00',
    endTimeMeridian: Meridian.AM,
  },
};

export const useSetDefaultTimeRange = (): void => {
  const { getValues, setValue } = useFormContext<IMealCreditFormFields>();
  const {
    formValues: { timeIntervalType },
  } = useMealCreditFormData();

  useEffect(() => {
    const { startTime, startTimeMeridian, endTime, endTimeMeridian } =
      getValues();

    const calculatedIntervalType = calculateTimeIntervalType({
      startTime,
      startTimeMeridian,
      endTime,
      endTimeMeridian,
    });

    const shouldSetDefaults = calculatedIntervalType !== timeIntervalType;

    if (shouldSetDefaults) {
      const defaultTimeRange = DEFAULT_TIME_RANGE[timeIntervalType];
      setValue('startTime', defaultTimeRange.startTime, {
        shouldValidate: true,
      });
      setValue('startTimeMeridian', defaultTimeRange.startTimeMeridian);
      setValue('endTime', defaultTimeRange.endTime, {
        shouldValidate: true,
      });
      setValue('endTimeMeridian', defaultTimeRange.endTimeMeridian);
    }
  }, [timeIntervalType, getValues, setValue]);
};
